export default "__VITE_ASSET__Bq_CFdU1__"